/* Purpose: All loan info (except SOW for FAF loans) can be viewed and edited from this form
 * Props: loanRequInfoList (list of map)
 *        handleRadioChange (func)
 *        handleTextInfoChange (func)
 *        handleClickSave (func)
 *        onBlur (func)
 *        stopSave (boolean)
 *        saveBtnText (str)
 *        next (func)
 *        back (func)
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/

import React, {useEffect} from "react";
import { Container, Form, Row, Col, Alert } from "react-bootstrap";
import SubmitButton from "./Button";
import { Link } from "react-router-dom";

const LoanInfoForm = ({loanRequInfoList, handleRadioChange, handleTextInfoChange, handleClickSave, onBlur, stopSave, saveBtnText, next, back}) => {
    useEffect(() => {
      window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
    }, [])

    return (
        <Container className = 'm-3'>
            <Form className='m-3'  noValidate>
                  {loanRequInfoList && loanRequInfoList.map((item, index) => (
                    <>
                        {(!item.notes || !item.notes.includes("SOW")) && (
                        <Col key ={index} className = "my-1" >
                        
                        {item.fieldType === "radio" ? (
                          <Form.Group type = "radio" key = {index} className = 'mt-2'>
                            <Form.Label>{item.fieldName}: </Form.Label>
                            {item.options.map((option, optionIndex) => (
                              <Form.Check 
                                  key = {optionIndex}
                                  type = "radio" 
                                  name = {item.fieldName}
                                  id = {item.fieldName + "-" + option} 
                                  label = {option}
                                  value = {item.value}
                                  checked = {item.value === option}
                                  onChange = {(event) => handleRadioChange(index, event, option)}
                              />
                            ))} 
                          </Form.Group>
                        ):(item.fieldType == "text"?(
                          <Form.Group key = {index} type="text"> 
                            <Form.Label>{item.fieldName}: </Form.Label>
                            <Form.Control 
                              id={item.fieldName} 
                              value= {item.value} 
                              disabled = {item.state === "disabled"}
                              placeholder={item.state?item.placeHolder:item.value}
                              onChange={(event) => {handleTextInfoChange(index, event)}}
                              isInvalid = {"isValid" in item?!item.isValid:false}
                              onBlur={() => {onBlur(item, index)}}
                            />
                            {item.toolTip &&(
                                <Form.Text id = {item.fieldName} muted>{item.toolTip}</Form.Text>
                            )}
                            <Form.Control.Feedback type = "invalid">{item.invalidMsg}</Form.Control.Feedback>
                        </Form.Group>
                        ):(<></>))}
                      </Col>
                        )}

                    </>
                  ))}
                </Form>

            {stopSave && (
              <Row className="align-items-center mt-3">
                <Alert className = "text-center w-80" variant = "danger" >Your changes have NOT been saved. One or more fields contain invalid data. Please fix your data and try saving again.</Alert>
              </Row>
            )}

            <Row  xs = {2} sm={2} md = {3} className='g-4 m-2'>
                <Col className='text-start' xs={{order: 2}} md = {{order: 1}}>
                    <Link className="mt-auto" onClick = {back}><SubmitButton text = "<< Back" width = "52"/></Link>
                </Col>
                <Col className='text-center' xs = {{span: '12', order: 1}} sm ={{span: '12', order: 1}} md = {{order: 2}}>
                    <SubmitButton text = {saveBtnText} onClick = {handleClickSave} width = "90"/>
                </Col>
                <Col className='text-end' xs = {{order: 3}} md = {{order: 3}}>
                    <Link onClick = {next} className="mt-auto"><SubmitButton text = "Next >>" width = "52"/></Link>
                </Col>
            </Row>
        </Container>

    );
};

export default LoanInfoForm;